import { StyleSheet } from "@react-pdf/renderer";

const blue = "#063AC9";

export default StyleSheet.create({
  mainTitleContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    margin: 0
  },
  mainTitle: {
    fontFamily: "Helvetica",
    color: blue,
    fontSize: "48pt",
    textAlign: "center",
    fontWeight: "medium",
    letterSpacing: 0,
    marginRight: "15pt"
  },
  subTitle: {
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "medium",
    fontSize: "24pt",
    height: "29pt",
    color: "#292d37"
  },
  page: {
    padding: 10,
    // flex: 1,
    backgroundColor: "#eaf2ff"
    // display: "flex",
    // flexDirection: "column",
    // justifyContent: "flex-start"
  },
  container: {
    width: "100%",
    flexGrow: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  halfContainer: {
    width: "49%"
  },
  mapImage: {
    objectFit: "contain",
    objectPosition: "left top"
  },
  section: {
    width: "100%",
    height: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start"
  },
  personaContainer: {
    display: "flex",
    height: "85%",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%"
  },
  demographicList: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    flexDirection: "row",
    alignContent: "flex-start",
    alignItems: "flex-start"
  }
});
